<div class="container-fluid py-3">
  <div class="row">

      <div class="col-12">

          <p-table #dt
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [filterDelay]="0"
              [loading]="serviceService.loading"
              [paginator]="true"
              [rows]="25"
              [rowHover]="true"
              [rowsPerPageOptions]="[25,50,100]"
              [showCurrentPageReport]="true" 
              [value]="serviceService.services"
              pDroppable="row">
              <ng-template pTemplate="caption">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4 d-flex align-items-center">
                      Tipos de visitas
                    </div>

                    <div class="col-8 text-end">
                      <button
                        (click)="open()"
                        class="btn btn-success rounded-circle me-2">
                        <i class="material-icons mt-1">add</i>
                      </button>

                      <button
                        (click)="serviceService.getAll(neighborhoodId!)"
                        class="btn btn-primary rounded-circle me-2">
                        <i class="material-icons mt-1">refresh</i>
                      </button>

                      <button
                        class="btn btn-light rounded-circle me-2">
                        <i class="material-icons mt-1">filter_alt_off</i>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                  <tr>

                    <th></th>

                    <th pSortableColumn="service">
                      Nombre
                      <p-sortIcon field="service"></p-sortIcon>
                      <p-columnFilter type="text" field="service" display="menu"></p-columnFilter>
                    </th>

                    <th pSortableColumn="createShortCode">
                      Generar código corto
                      <p-sortIcon field="createShortCode"></p-sortIcon>
                    </th>

                    <th pSortableColumn="showResident">
                      Mostrar a residentes
                      <p-sortIcon field="showResident"></p-sortIcon>
                    </th>

                    <th pSortableColumn="descriptionRequired">
                      ¿Requiere campo descripción?
                      <p-sortIcon field="descriptionRequired"></p-sortIcon>
                    </th>

                    <th pSortableColumn="status">
                      Estatus
                      <p-sortIcon field="status"></p-sortIcon>
                    </th>

                    <th></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service let-rowIndex="rowIndex">
                  <tr class="p-selectable-row">

                    <td>
                      @if(service.image) {
                        <div 
                          class="bg-center"
                          style="width: 5vh; height: 5vh;"
                          [ngStyle]="{
                            'background-image': 'url(' + service.image.urlFile + ')'
                          }">
                        </div>
                      }
                    </td>

                    <td>
                      <span class="p-column-title">Nombre</span>
                      {{service.service}}
                    </td>

                    <td>
                      <span class="p-column-title">Generar código corto</span>
                      <p-inputSwitch
                        (onChange)="update(service)"
                        [(ngModel)]="service.createShortCode">
                      </p-inputSwitch>
                    </td>

                    <td>
                      <span class="p-column-title">Mostrar a residentes</span>
                      <p-inputSwitch
                        (onChange)="update(service)"
                        [(ngModel)]="service.showResident">
                      </p-inputSwitch>
                    </td>

                    <td>
                      <span class="p-column-title">¿Requiere campo descripción?</span>
                      <p-inputSwitch
                        (onChange)="update(service)"
                        [(ngModel)]="service.descriptionRequired">
                      </p-inputSwitch>
                    </td>

                    <td>
                      <span class="p-column-title">Estatus</span>
                      <!-- {{brand.status}} -->
                      <p-inputSwitch
                        (onChange)="update(service)"
                        [(ngModel)]="service.status">
                      </p-inputSwitch>
                    </td>

                    <td>

                      <button
                        (click)="open(service)"
                        class="btn btn-sm btn-light rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">edit</i>
                      </button>

                      <button
                        (click)="delete(service)"
                        class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">delete</i>
                      </button>
                    </td>
                  </tr>
              </ng-template>
          </p-table>

      </div>

  </div>
</div>